class WellnessCollectionSort extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
    this.addEventListener('submit', this.#handleSubmit);
    window.addEventListener('pageshow', this.#restoreSelections);
    this.#restoreSelections();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
    this.removeEventListener('submit', this.#handleSubmit);
    window.removeEventListener('pageshow', this.#restoreSelections);
  }

  #restoreSelections = () => {
    // Browsers can restore the last form value even when history restores an older page.
    // The server-rendered selected attributes describe the products on this page.
    this.querySelectorAll('select').forEach((select) => {
      const option = Array.from(select.options).find((item) => item.defaultSelected);
      if (option) select.value = option.value;
    });
  };

  #handleChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    if (event.target.name !== 'sort_by') return;

    this.#updateSort(event.target);
  };

  #handleSubmit = (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;

    const select = event.target.querySelector('select[name="sort_by"]');
    if (!(select instanceof HTMLSelectElement)) return;

    event.preventDefault();
    this.#updateSort(select);
  };

  #updateSort(select) {
    const form = select.form;
    if (!form) return;

    const nextUrl = new URL(window.location.href);
    const actionUrl = new URL(form.action, window.location.origin);

    nextUrl.pathname = actionUrl.pathname;
    nextUrl.searchParams.delete('page');
    nextUrl.searchParams.delete('section_id');
    nextUrl.searchParams.set('sort_by', select.value);
    nextUrl.hash = 'ResultsList';

    // A normal navigation keeps Back/Forward, the selected option, and product order in sync.
    window.location.assign(nextUrl.toString());
  }
}

if (!customElements.get('wellness-collection-sort')) {
  customElements.define('wellness-collection-sort', WellnessCollectionSort);
}
